module.exports = __webpack_public_path__ + "img/charge_btn.546ee94c.png";